
import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { useField, useFormikContext } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackStyling, formLabelStyling, descriptionStyling, dropDownFormStyle } from 'components/forms/new/formStyles';

const options = [
    { label: 'Prefix', value: 'prefix' },
    { label: 'Pattern', value: 'pattern' },
];

const PrefixPatternTypeField = ({ darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [ meta] = useField('prefixType');
    const { setFieldValue, values } = useFormikContext();
    const error = meta.error;
    const showError = meta.touched;
    return (
        <FormControl
            sx={{ margin: '0 0 24px 0 !important', width: '100%' }}
            isInvalid={!!error && showError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" alignItems="flex-start" sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Prefix Type <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Choose whether to use a Prefix or Pattern for this block rate.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                                   <Box sx={{
                                                                                               display: 'flex',
                                                                                               alignItems: 'flex-start',
                                                                                              marginTop: '24px',
                                                                                           }}>
                    
                        <VStack width="100%" alignItems="normal">
                            <Select
                                placeholder="- Select Type -"
                                value={options.find(opt => opt.value === values.prefixType) || null}
                                onChange={e => {
                                    setFieldValue('prefixType', e.value);
                                    // Don't clear the opposite field - keep both values so user can switch back
                                    // if (e.value === 'prefix') {
                                    //     setFieldValue('pattern', '');
                                    // } else if (e.value === 'pattern') {
                                    //     setFieldValue('prefix', '');
                                    // }
                                }}
                                options={options}
                                chakraStyles={dropDownFormStyle(darkMode)}
                                menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                            {showError && (
                                <Text color="red.500" fontSize="xs" mt={1} textAlign="right">
                                    {error}
                                </Text>
                            )}
                        </VStack>
                        </Box>
                    </Box>
            
                {isHovered && (
                    <FieldToolTip
                        label="Choose Prefix or Pattern."
                        ariaLabel="prefix-pattern-type-tip"
                        left="25px"
                        top="30px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PrefixPatternTypeField;
